var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWriting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106.147,
    height: 106.15,
    viewBox: "0 0 106.147 106.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "writing",
    transform: "translate(-0.006 0)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M425.491,154.833a6.228,6.228,0,0,0-8.324-.426c-.353.288-.08.034-5.456,5.411l13.956,13.956,5.016-4.953a6.227,6.227,0,0,0,0-8.8Z",
    transform: "translate(-326.349 -121.291)",
    fill: "#a9afbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M241.163,231.527l-8.21,17.592a3.11,3.11,0,0,0,4.133,4.133l17.592-8.21c.7-.325-1.411,1.647,24.635-24.073l-13.929-13.929c-25.824,25.824-23.891,23.777-24.222,24.486Z",
    transform: "translate(-184.42 -164.116)",
    fill: "#a9afbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M75.5,84.748a9.307,9.307,0,0,1-2.609,1.815L55.3,94.773a9.33,9.33,0,0,1-12.4-12.4l8.21-17.593a9.305,9.305,0,0,1,1.857-2.651L79.411,35.682V9.33A9.34,9.34,0,0,0,70.082,0H9.336A9.34,9.34,0,0,0,.006,9.33V96.82a9.34,9.34,0,0,0,9.33,9.33H70.082a9.34,9.34,0,0,0,9.33-9.33V80.883ZM16.592,20.11H63.033a3.11,3.11,0,0,1,0,6.22H16.592a3.11,3.11,0,1,1,0-6.22Zm0,16.586H53.081a3.11,3.11,0,0,1,0,6.22H16.592a3.11,3.11,0,1,1,0-6.22Zm-3.11,19.7a3.11,3.11,0,0,1,3.11-3.11H43.13a3.11,3.11,0,0,1,0,6.22H16.592A3.11,3.11,0,0,1,13.482,56.392Z",
    fill: "#a9afbc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriting);
export default __webpack_public_path__ + "static/media/writing.3a5989659598b7c089e9253c2ca5aefe.svg";
export { ForwardRef as ReactComponent };